import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Bars from "../assets/icon/btn_totalMenu.png";
import * as S from "../Style/Header/Header.style";
import Logo from "../assets/logo/ci.png";
import Arrow from "../assets/icon/btn_language.png";

const Header = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSections, setActiveSections] = useState({});
  const menuRef = useRef(null);
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "kor"
  );
  console.log(localStorage.getItem("language"));
  if (localStorage.getItem("language") === null) {
    localStorage.setItem("language", "kor");
  }
  // Language toggle function
  const handleLanguageToggle = () => {
    const newLanguage = language === "kor" ? "eng" : "kor";
    setLanguage(newLanguage);
    localStorage.setItem("language", newLanguage);

    // Reload the page
    window.location.reload();
  };

  const handleMenuClick = () => {
    setIsMenuOpen(true);
    document.getElementById("toggle-open").style.right = "0%";
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      closeMenu();
    }
  };

  useEffect(() => {
    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  const toggleSection = (sectionId) => {
    setActiveSections((prevSections) => {
      const isSectionAlreadyOpen = !!prevSections[sectionId];

      // 모든 섹션을 닫은 다음, 현재 섹션만 열도록 설정
      return {
        [sectionId]: !isSectionAlreadyOpen, // 클릭된 섹션만 토글
      };
    });
  };

  const closeMenu = () => {
    if (window.innerWidth <= 1024) {
      setIsMenuOpen(false);
      document.getElementById("toggle-open").style.right = "-100%";
      closeAllSections();
    }
  };

  const closeAllSections = () => {
    setActiveSections({});
  };

  const renderLink = (to, label) => (
    <Link to={to} className="header-link" onClick={closeMenu}>
      {label}
    </Link>
  );

  const renderSection = (sectionId, label, links) => (
    <div
      className="link-vertical-line"
      id={sectionId}
      style={{ height: activeSections[sectionId] ? "100%" : "62px" }}
    >
      <div
        className="header-link mobile-show"
        onClick={() => toggleSection(sectionId)}
      >
        {label}
      </div>
      {links.map(({ to, label }) => renderLink(to, label))}
    </div>
  );

  return (
    <S.HeaderArea
      color={props.color}
      className={localStorage.getItem("language")}
    >
      <div className="wrap">
        <div className="inner">
          <div className="header-left">
            <Link to="/" onClick={closeMenu}>
              <img src={Logo} alt="Logo" className="logo" />
            </Link>
          </div>

          <div className="kor">
            <div className="header-center">
              {renderLink("/HatBusiness/Introduce", "모자사업", "")}
              {renderLink("/ForkLiftBusiness/Introduce", "지게차사업", "")}
              {renderLink("/BusBusiness/OverseasBus", "버스사업", "")}

              {renderLink("/CarBusiness/introduce", "자동차사업", "")}
              {renderLink("/GeneralBusiness/introduce", "일반사업", "")}
              {renderLink("/SocialBusiness/SocialService", "사회사업", "")}
              {renderLink("/WBH/WBH", "WBH", "")}
            </div>
          </div>
          <div className="eng">
            <div className="header-center">
              {renderLink("/HatBusiness/Introduce", "Hat Business", "")}
              {renderLink("/ForkLiftBusiness/Introduce", "ForkLift Business", "")}
              {renderLink("/BusBusiness/OverseasBus", "Bus Business", "")}

              {renderLink("/CarBusiness/introduce", "Car Business", "")}
              {renderLink("/GeneralBusiness/introduce", "General Business", "")}
              {renderLink("/SocialBusiness/SocialService", "Social Business", "")}
              {renderLink("/WBH/WBH", "WBH", "")}
            </div>
          </div>
          <div className="header-right">
            <div
              className="header-right-menu mobile-show"
              onClick={handleMenuClick}
            >
              <span>전체메뉴</span>
              <img src={Bars} alt="Menu Bars" />
            </div>
            <div className="header-right-menu" onClick={handleLanguageToggle}>
              <span>{language === "kor" ? "ENGLISH" : "한국어"}</span>
              <img src={Arrow} alt="Language Arrow" />
            </div>
          </div>
        </div>
      </div>
      <S.HeaderToggleOpen id="toggle-open" ref={menuRef}>
      <div className="kor">
        <div className="wrap">
          <div className="inner">
            <div className="link-flex-line">
              {renderSection("toggle-1", "모자사업", [
                {
                  to: "/HatBusiness/Introduce",
                  label: "모자사업",
                },
                {
                  to: "/HatBusiness/KoreaCompany",
                  label: "영안모자 한국본사",
                },
                {
                  to: "/HatBusiness/ProductionCorporation",
                  label: "직경영사업장",
                },
                {
                  to: "/HatBusiness/SalesCorporation",
                  label: "위탁경영사업장",
                },
                {
                  to: "/HatBusiness/History",
                  label: "주요사업이력",
                },
              ])}
              {renderSection("toggle-2", "지게차사업", [
                {
                  to: "/ForkLiftBusiness/Introduce",
                  label: "클라크",
                },
                {
                  to: "/ForkLiftBusiness/HeadOfficeUsa",
                  label: "지역별법인",
                },
                {
                  to: "/ForkLiftBusiness/History",
                  label: "주요사업이력",
                },
              ])}
              {renderSection("toggle-4", "버스사업", [
                {
                  to: "/BusBusiness/OverseasBus",
                  label: "해외 상용버스사업",
                },
                { to: "/BusBusiness/Factory", label: "생산공장" },
                {
                  to: "/BusBusiness/BusBusinessHistory",
                  label: "버스사업이력",
                },
              ])}
              {renderSection("toggle-3", "자동차사업", [
                {
                  to: "/CarBusiness/introduce",
                  label: "한국 자동차사업",
                },
                {
                  to: "/CarBusiness/AsService",
                  label: "A/S 정비사업",
                },
                {
                  to: "/CarBusiness/CarBusinessHistory",
                  label: "자동차사업이력",
                },
              ])}

              {renderSection("toggle-5", "일반사업", [
                {
                  to: "/GeneralBusiness/introduce",
                  label: "일반사업소개",
                },
                {
                  to: "/GeneralBusiness/History",
                  label: "주요사업이력",
                },
              ])}
              {renderSection("toggle-6", "사회사업", [
                {
                  to: "/SocialBusiness/SocialService",
                  label: "복지사업",
                },
                {
                  to: "/SocialBusiness/Scholarship",
                  label: "연암장학회",
                },
                {
                  to: "/SocialBusiness/EducationBusiness",
                  label: "교육사업",
                },
                { to: "/SocialBusiness/Obs", label: "OBS" },
                {
                  to: "/SocialBusiness/Museum",
                  label: "영안역사관",
                },
              ])}
              {renderSection("toggle-7", "WBH", [
                { to: "/WBH/WBH", label: "WBH" },
              ])}
            </div>
          </div>
        </div>
        </div>
        <div className="eng">
        <div className="wrap">
          <div className="inner">
            <div className="link-flex-line">
              {renderSection("toggle-1", "Hat Business", [
                {
                  to: "/HatBusiness/Introduce",
                  label: "Hat Business",
                },
                {
                  to: "/HatBusiness/KoreaCompany",
                  label: "Youngan Hat Korean HQ",
                },
                {
                  to: "/HatBusiness/ProductionCorporation",
                  label: "Production Corporation",
                },
                {
                  to: "/HatBusiness/SalesCorporation",
                  label: "Sales Corporation",
                },
                {
                  to: "/HatBusiness/History",
                  label: "Hat History",
                },
              ])}
              {renderSection("toggle-2", "ForkLift Business", [
                {
                  to: "/ForkLiftBusiness/Introduce",
                  label: "ForkLift Business",
                },
                {
                  to: "/ForkLiftBusiness/HeadOfficeUsa",
                  label: "Regional Corporations",
                },
                {
                  to: "/ForkLiftBusiness/History",
                  label: "ForkLift History",
                },
              ])}
              {renderSection("toggle-4", "Bus Business", [
                {
                  to: "/BusBusiness/OverseasBus",
                  label: "Bus Business",
                },
                { to: "/BusBusiness/Factory", label: "Production Factory" },
                {
                  to: "/BusBusiness/BusBusinessHistory",
                  label: "Bus History",
                },
              ])}
              {renderSection("toggle-3", "Car Business", [
                {
                  to: "/CarBusiness/introduce",
                  label: "Korea Car Business",
                },
                {
                  to: "/CarBusiness/AsService",
                  label: "A/S Service Business",
                },
                {
                  to: "/CarBusiness/CarBusinessHistory",
                  label: "Car History",
                },
              ])}

              {renderSection("toggle-5", "General Business", [
                {
                  to: "/GeneralBusiness/introduce",
                  label: "General Business",
                },
                {
                  to: "/GeneralBusiness/History",
                  label: "General History",
                },
              ])}
              {renderSection("toggle-6", "Social Business", [
                {
                  to: "/SocialBusiness/SocialService",
                  label: "Social Business",
                },
                {
                  to: "/SocialBusiness/Scholarship",
                  label: "Scholarship Foundation",
                },
                {
                  to: "/SocialBusiness/EducationBusiness",
                  label: "Education Business",
                },
                { to: "/SocialBusiness/Obs", label: "OBS" },
                {
                  to: "/SocialBusiness/Museum",
                  label: "Youngan History",
                },
              ])}
              {renderSection("toggle-7", "WBH", [
                { to: "/WBH/WBH", label: "WBH" },
              ])}
            </div>
          </div>
        </div>
        </div>
      </S.HeaderToggleOpen>
    </S.HeaderArea>
  );
};

export default Header;
